/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'babel-polyfill'

require('./bootstrap')

/**
 * Enable Vuex with Pathify
 */
import store from './store'
window.store = store

Vue.use(require('keen-ui/dist/keen-ui.js'))

// Components
Vue.component('Card', () => import('./components/Card'))
Vue.component('Loader', () => import('./components/Loader'))
Vue.component('Confirm', () => import('./components/Confirm'))
Vue.component('Paging', () => import('./components/Paging'))
Vue.component('CopyActivities', () => import('./components/CopyActivities'))
Vue.component('Chart', () => import('./components/Charts/Chart'))
Vue.component('BarChart', () => import('./components/Charts/BarChart'))
Vue.component('LineChart', () => import('./components/Charts/LineChart'))

require('./components/dropdown')

Vue.component('Activities', () => import('./components/Activities'))
Vue.component('CategoryGraph', () => import('./components/CategoryGraph'))
Vue.component('Users', () => import('./components/Users'))

Vue.component('Categories', () => import('./components/Settings/Categories'))
Vue.component('Classifications', () => import('./components/Settings/Classifications'))
Vue.component('ActivitiesSettings', () => import('./components/Settings/ActivitiesSettings'))
Vue.component('Norms', () => import('./components/Settings/ActivitiesSettings'))
Vue.component('Norms', () => import('./components/Settings/Norms'))

Vue.component('Titles', () => import('./components/Settings/Titles'))
Vue.component('UsersSettings', () => import('./components/Settings/UsersSettings'))
Vue.component('Years', () => import('./components/Settings/Years'))
Vue.component('UnitTypesSettings', () => import('./components/Settings/UnitTypesSettings'))
Vue.component('SectionSettings', () => import('./components/Settings/SectionSettings'))

Vue.component('ProgrammesSettings', () => import('./components/Settings/ProgrammesSettings'))
Vue.component('YearCopyContent', () => import('./components/Settings/YearCopyContent'))
Vue.component('Notes', () => import('./components/Notes'))
Vue.component('Widget', () => import('./components/Widget'))
Vue.component('UserActivities', () => import('./components/UserActivities'))
Vue.component('ActivityMigration', () => import('./components/ActivityMigration'))

require('../../packages/WISEflow/src/resources/js')
require('./ui-components')
require('./components')

/**
 * Webix
 * - Pivot
 */
require('../../packages/Pivot/src/resources/assets/js')

/**
 * Course
 */
require('../../packages/Course/src/resources/assets/js')

Vue.mixin(require('./trans'))

Vue.mixin({
    computed: {
        $user() {
            return _global.user
        }
    },
    methods: {
        hasRole(role) {
            for (var i in _global.user.roles) {
                if (_global.user.roles[i].key === role)
                    return true;
            }

            return false;
        }
    }
})

const app = new Vue({
    el: '#app',
    store,
    /*methods: {
        moment() {
            return moment();
        }
    }*/
})
